import { Flex } from "@/components/atoms/flex";
import { useStyle } from "./style";

export const UnavailableConversationPlaceholder: React.FC<{
	message: string;
}> = ({ message }) => {
	const classes = useStyle();

	return (
		<Flex className={classes.unavailableConversationPlaceholderRoot}>
			<Flex
				hAlign="center"
				vAlign="center"
				className={classes.unavailableConversationPlaceholder}
			>
				{message}
			</Flex>
		</Flex>
	);
};
